export enum ConsentServiceType {
  Platform = 0,
  Shipping = 1,
  Billing = 2
}
